import moment from "moment";
import React, { useState } from "react";
import DatePicker from "react-date-picker";
import { Passenger } from "../types/flights";
import { CustomInput } from "../Common/Ui/CustomInput";

const PassportDetails: React.FC<{
  // closePopup: () => void;
  onChange(index);
  index: number;
  updateQuery;
  pass: Passenger;
}> = (props) => {
  const closePopUp = () => {
    props.onChange(props.index);
    props.updateQuery((old: Passenger[]) => {
      old[props.index].passportCountry = undefined;
      old[props.index].passportExpiry = undefined;
      old[props.index].passportNumber = undefined;
      old[props.index].isPassportWindow = false;
      return [...old];
    });
  };

  return (
    <div>
      <div className="form-group py-1 rounded">
        <div className="row">
          <div className="col-lg-4">
            <CustomInput
              id="passport_number"
              label="PassPort Number"
              type="text"
              value={props.pass.passportNumber || ""}
              onChange={(e) => {
                props.updateQuery((old: Passenger[]) => {
                  old[props.index].passportNumber = e.target.value;
                  return [...old];
                });
              }}
            />
          </div>
          <div className="col-lg-4">
            <label>Expiry Date</label>
            <DatePicker
              className="bg-white w-100 form-control"
              value={
                props?.pass?.passportExpiry
                  ? moment(props?.pass?.passportExpiry).toDate()
                  : null
              }
              clearIcon={null}
              onChange={(date) => {
                props.updateQuery((old: Passenger[]) => {
                  old[props.index].passportExpiry =
                    moment(date).format("YYYY-MM-DD");
                  return [...old];
                });
              }}
              format="dd-MM-y"
              dayPlaceholder="DD"
              monthPlaceholder="MM"
              yearPlaceholder="YYYY"
              minDate={moment().toDate()}
            />
          </div>
          <div className="col-lg-4 small">
            <CustomInput
              id="country"
              label="Country"
              type="text"
              value={props.pass.passportCountry || ""}
              onChange={(e) => {
                props.updateQuery((old: Passenger[]) => {
                  old[props.index].passportCountry = e.target.value;

                  return [...old];
                });
              }}
            />
          </div>
        </div>
      </div>

      <div className="small text-end">
        <button
          className="btn text-danger small p-1 cancel-button"
          onClick={closePopUp}
        >
          <i className="fa-solid fa-xmark text-danger"></i> Cancel
        </button>
      </div>
    </div>
  );
};

export default PassportDetails;
